import { StrichSDK } from '@pixelverse/strichjs-sdk';
import React, { FC, useEffect, useState } from 'react';
import { useTitle } from 'react-use';

import { logVerbose } from '@savgroup-front-common/configuration/appInsights/AppInsights';
import { buildPageTitle } from '@savgroup-front-common/core/helpers';
import { BaseLoader } from '@savgroup-front-common/core/molecules/BaseLoader';
import { RoutedStepProps } from '@savgroup-front-common/core/molecules/RoutedStepsOrchestrator/RoutedStepsOrchestrator.types';

import { IrshStepValues } from '../IrshPages.types';

import { CartManager } from './CartManager';
import messages from './messages';

const strichLicenceKey = import.meta.env.VITE_STRICH_LICENCE_KEY;
const shouldUseStrich = !!strichLicenceKey;

const ProductsToReturnPage: FC<RoutedStepProps<IrshStepValues>> = ({
  onPreviousStep,
  onNextStep,
}) => {
  const [isStrichReady, setIsStrichReady] = useState(!shouldUseStrich);

  useTitle(buildPageTitle([messages.productsToReturnTitlePage]));

  useEffect(() => {
    if (!shouldUseStrich) {
      return;
    }

    StrichSDK.initialize(strichLicenceKey).then(() => {
      logVerbose('STRICH SDK initialized');
      setIsStrichReady(true);
    });
  }, []);

  if (!isStrichReady) {
    return <BaseLoader />;
  }

  return (
    <CartManager onNextStep={onNextStep} onPreviousStep={onPreviousStep} />
  );
};

export default React.memo(ProductsToReturnPage);
